import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from 'react';
import _ from 'lodash';
import BaseModal from 'components/BaseModal';
import { LoadingIcon } from 'components/Icons';
import message from "components/CustomMessage";

function PagerDutyOAuthPopup({ afterClose: _afterClose, ...props }, ref) {
    const isEdit = !_.isUndefined(props?.id)
    const errorRef = useRef(false);
    const failedStatusRef = useRef(true);
    const thisRef = useRef();
    //login id is used in Mapping Form Modal once OAuth login is successful
    const loginIdRef = useRef();
    const URL = isEdit ? `/user/tickets/pagerduty/oauth2/redirect?state=${props.id}` : "/user/tickets/pagerduty/oauth2/redirect";
    useImperativeHandle(ref,() => ({
        ...thisRef
    }))

    const afterClose = useCallback(() => {
        _afterClose && _afterClose(failedStatusRef.current, loginIdRef.current);
    }, [_afterClose]);

    useEffect(() => {
        const _window = window.open(URL, "_blank", "width=1000,height=800,rel=noopener");
        if(_.isNull(_window)){
            message.error("Pop-up window is blocked on your browser, please enable and retry.");
            afterClose()
            return false;
        }
        const timer = setInterval(function() { 
            try {
                // _window becomes null if the popup window is blocked by the browser.
                // User closes the OAuth window before access
                if(!_window || _window.closed) {
                    clearInterval(timer);
                    message.error("Unable to connect to PagerDuty, please try again.");
                    thisRef.current.close();
                    return;
                }
                if(_window.location.pathname.endsWith("oauth2")){
                    const bodyText = _window.document.body.innerText;
                    const closeModal = () => {
                        _window.close();
                        thisRef.current.close();
                        clearInterval(timer);
                    };
                    //body text contains an extra plain string due to xml parser gives error
                    //extract only xml string
                    const xmlIndex = bodyText.indexOf("<");
                    let successVal = "";
                    let idVal = "";
                    if(xmlIndex !== -1){
                        const bodyXmlOnlyText = bodyText.substring(xmlIndex);
                        const parser = new DOMParser();
                        const xmlDoc = parser.parseFromString(bodyXmlOnlyText, 'text/xml');
                        successVal = xmlDoc.querySelector('success').textContent;
                        idVal = xmlDoc.querySelector('message').textContent;
                    }
                    if(successVal === "true" && idVal) {
                        loginIdRef.current = idVal;
                        failedStatusRef.current = false;
                        closeModal();
                        return;
                    } else if(errorRef.current){
                        closeModal();
                    }
                }
            } catch (e) {errorRef.current = true}
        }, 1000);
        return () => {
            clearInterval(timer);
            _window.close();
        }
    }, [afterClose, URL]);

    return (
        <BaseModal
            modalProps={{
                title: "Connecting PagerDuty",
                footer: null
            }}
            ref={thisRef}
            afterClose={afterClose}
        >
            <LoadingIcon /> Waiting for PagerDuty OAuth.
        </BaseModal>
    )
}

export default forwardRef(PagerDutyOAuthPopup);